import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { ModalsService } from '@ib-core/services/modals.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'ib-img-view',
  templateUrl: './img-view.component.html',
  styleUrls: ['./img-view.component.scss'],
})
export class ImgViewComponent
  extends AbstractBaseComponent
  implements OnDestroy, AfterViewInit, OnInit
{
  @Input() document: ISelectedDocument;

  public modalRef: MatDialogRef<TemplateRef<HTMLElement>>;
  public pdfSrc: any;
  @ViewChild('modalTmpl') modalTmpl: TemplateRef<HTMLElement>;

  @Output() closeMe = new EventEmitter<void>();

  constructor(private modalsS: ModalsService) {
    super();
  }

  ngOnInit(): void {
    if (this.document.isFilePdf && typeof FileReader !== 'undefined') {
      const reader = new FileReader();
      reader.onload = e => {
        this.pdfSrc = e.target.result;
      };
      reader.onerror = e => {
        console.error(e);
      };
      reader.readAsArrayBuffer(this.document.file);
    }
  }

  ngOnDestroy(): void {
    this.modalRef?.close();
    super.destroySubscriptions();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.openModal();
    });
  }

  openModal(): void {
    this.modalRef = this.modalsS.openModal(this.modalTmpl, {
      width: '100vw',
      height: '100vh',
      panelClass: 'ib-modal-img-view',
    });
    this.modalRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.closeMe.emit();
      });
  }
}
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ISelectedDocument } from '../selected-docs/selected-docs.component';

@NgModule({
  declarations: [ImgViewComponent],
  imports: [CommonModule, MatDialogModule, PdfViewerModule],
  exports: [ImgViewComponent],
})
export class ImgViewModule {}
